import { defineComponent, computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { Toast } from 'vant';
import { Auth } from '@nio-pow/mfe-vue3';
import { t } from '@/i18n';
export default defineComponent({
    name: 'MenuMobileComp',
    components: {},
    props: {
        showBorder: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: ()=>[]
        },
        optionAsValue: {
            type: Boolean,
            default: false
        }
    },
    setup (props) {
        const route = useRoute();
        const activeTab = ref(0);
        const listAuthed = computed(()=>props.list.filter((item)=>{
                let res = true;
                if (item.auth) {
                    if (Array.isArray(item.auth)) {
                        res = item.auth.some((auth)=>Auth.hasPermission(auth));
                    } else {
                        res = Auth.hasPermission(item.auth);
                    }
                }
                return res;
            }));
        function findActiveTab() {
            const path = route.path;
            let targetActiveTab = -1;
            // 优先通过 link 精确匹配
            listAuthed.value.some((item, index)=>{
                const res = path === item.link;
                if (res) targetActiveTab = index;
                return res;
            });
            // 其次通过 activeRule 进行正则匹配
            if (targetActiveTab < 0) {
                listAuthed.value.some((item, index)=>{
                    const res = item.activeRule ? new RegExp(item.activeRule).test(path) : false;
                    if (res) targetActiveTab = index;
                    return res;
                });
            }
            if (targetActiveTab >= 0) {
                activeTab.value = targetActiveTab;
            }
        }
        const handleTabbarChange = (index)=>{
            var _listAuthed_value_index;
            if ((_listAuthed_value_index = listAuthed.value[index]) === null || _listAuthed_value_index === void 0 ? void 0 : _listAuthed_value_index.needLoading) {
                Toast.loading({
                    message: t('loading'),
                    forbidClick: true,
                    duration: 5000
                });
            }
        };
        watch(()=>listAuthed, ()=>{
            findActiveTab();
        });
        watch(()=>route, ()=>{
            findActiveTab();
        });
        findActiveTab();
        return {
            activeTab,
            listAuthed,
            findActiveTab,
            handleTabbarChange
        };
    }
});
